import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root',
})
export class MeasureService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/mesureterrain`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    addLingette(code: string, count: number = 1) {
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/lingette/${code}/${count}`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('addLingette')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    addMassif(code: string, count: number = 1) {
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/massif/${code}/${count}`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('addMassif')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));

    }

    addEau(code: string, count: number = 1) {
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/eau/${code}/${count}`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('addEau')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));

    }

    changeLetterForOfASampling(code: string, samplingId: number, newMeasureReferenceCode: string) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/chip/${code}/${samplingId}/${newMeasureReferenceCode}`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('changeLetterForOfASampling')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));

    }
}